import { render, staticRenderFns } from "./Phrase.vue?vue&type=template&id=026af868&scoped=true&"
import script from "./Phrase.vue?vue&type=script&lang=js&"
export * from "./Phrase.vue?vue&type=script&lang=js&"
import style0 from "./Phrase.vue?vue&type=style&index=0&id=026af868&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026af868",
  null
  
)

export default component.exports